import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import styled from 'styled-components';
import Card from './Card';
import EmailConfirmation from './EmailConfirmation';
import Footer from './Footer';
import Form from './SignUpForm';
import ThanksCard from './ThanksCard';
import { ReactComponent as PhotoLens } from '../assets/photo-lens.svg';
import EmilyBurns from '../assets/img/Emily-Burns.png';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  font-family: Roboto;
`;

const Header = styled.header`
  margin-top: 18em;

  &.emily {
    display: flex;
    align-items: center;
  }

  &.gary {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const YoutubeIFrame = styled.div`
  width: 100%;
  max-width: 414px;
  height: 230px;
  margin-bottom: 1em;

  & > iframe {
    width: 100%;
    height: 100%;
  }
`;

const Logo = styled.div``;

const EmilyBurnsPhoto = styled.img`
  height: 95px;
  width: 95px;
`;

const GaryBarlowCta = styled.p`
  text-transform: uppercase;
  text-align: center;
  color: white;
  font-weight: bold;
  margin: 1em 0;
`;

const Title = styled.h3<{ celebName: string }>`
  text-align: center;
  color: #ffffff;
  margin-bottom: 9rem;
  margin-top: 9rem;
  line-height: 2rem;
  font-size: ${({ celebName }: { celebName: string }) =>
    celebName === 'emily' ? `1.8em` : `1.1em`};
  font-family: ${({ celebName }: { celebName: string }) =>
    celebName === 'emily' ? `'Kapelka-New', 'KapelkaNew', serif` : `DoubleWideMedium`};
  text-transform: ${({ celebName }: { celebName: string }) =>
    celebName === 'emily' ? `none` : `uppercase`};
`;

export default function NewLandingPage({ celebName }: { celebName: string }) {

  const [email, setEmail] = useState('');
  const [comeFrom, setComeFrom] = useState('');
  const name = celebName === 'emily' ? 'Emily Burns' : 'Gary Barlow';

  useEffect(() => {
    /**
     * if we have other query strings too, we should add some permanent solution 
     */
    const qs = window.location.search;
    if (qs) {
      setComeFrom((qs.split('=')?.[1] || '').toLowerCase());
    }
  }, []);

  return (
    <Root>
      <Header className={celebName === 'emily' ? 'emily' : 'gary'}>
        <Logo>
          <PhotoLens />
        </Logo>
        {celebName === 'emily' && (
          <EmilyBurnsPhoto src={EmilyBurns} alt="Emily Burns" />
        )}
        {celebName === 'gary' && (
          <GaryBarlowCta>
            <svg
              width="294"
              height="17"
              viewBox="0 0 294 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.3787 7.8229H65.4339V4.31551H75.2901C77.3635 4.31551 78.5664 4.56015 79.0758 5.08632C79.2962 5.31354 79.3923 5.60088 79.3807 5.98773C79.3318 7.14995 78.6612 7.8229 75.3787 7.8229ZM87.0851 16.5066L80.1515 10.9443C83.3176 10.2328 85.0485 8.48839 85.0485 5.98027C85.0485 2.26805 81.9706 0.223073 76.3811 0.223073H59.7885V16.5066H65.4339V11.6699H74.1411L79.886 16.5066H87.0851ZM28.5984 15.3829L28.6461 6.73117H15.8338L15.7804 10.6005H22.9977V12.5626C20.9218 12.6501 18.8848 12.7036 17.6173 12.7036C9.24108 12.7036 5.82398 11.4854 5.82398 8.49876C5.82398 5.5901 9.47758 4.11483 16.6821 4.11483C20.1203 4.11483 26.6832 4.66463 27.3314 4.73678L27.664 4.77368L28.1242 1.21654L27.8251 1.14605C26.1315 0.745098 19.7434 0 16.6821 0C5.457 0 0 2.74363 0 8.38722C0 13.9226 5.82936 16.7288 17.327 16.7288C18.7104 16.7288 23.9466 16.4133 27.2825 15.6902C27.3177 15.6819 28.482 15.4107 28.5984 15.3829ZM111.75 0.223073H105.793L98.4054 7.39915L91.0195 0.223073H85.0866H84.2205L95.5496 11.0077V16.5066H101.195V10.9194L112.58 0.223073H111.75ZM286.798 16.5066L293.931 0.223073H288.016L283.505 11.3506L277.562 0.223073H272.944L267.066 11.3722L262.492 0.223073H256.577L263.688 16.5066H269.327L275.244 5.13524L281.181 16.5066H286.798ZM242.374 4.02568C233.586 4.02568 233.586 7.30834 233.586 8.38722C233.586 9.46029 233.586 12.7264 242.374 12.7264C251.183 12.7264 251.183 9.46029 251.183 8.38722C251.183 5.45202 248.301 4.02568 242.374 4.02568ZM242.374 16.7288C232.557 16.7288 227.785 14.0005 227.785 8.38722C227.785 2.74363 232.557 0 242.374 0C255.126 0 257.03 5.25466 257.03 8.38722C257.03 14.0785 252.373 16.7288 242.374 16.7288ZM227.026 16.5066V12.5033H211.442V0.223073H205.797V16.5066H227.026ZM165.4 9.76173L161.774 4.79649L158.13 9.76173H165.4ZM170.329 16.5066L168.126 13.498H155.403L153.198 16.5066H147.2L159.401 0.223073H164.172L176.325 16.5066H170.329ZM137.5 6.50768C138.526 6.50768 140.255 6.35634 140.299 5.34132C140.314 5.12032 140.26 4.95612 140.13 4.8168C139.751 4.41005 138.762 4.20398 137.189 4.20398H128.668V6.50768H137.5ZM138.792 12.5481C141.58 12.5481 141.902 11.8142 141.902 11.2623C141.888 10.5786 140.667 10.1324 138.792 10.1324H128.668V12.5481H138.792ZM123.023 16.5066V0.223073H138.169C141.507 0.223073 145.945 0.672122 145.945 4.55393C145.945 5.92139 145.11 7.13254 143.705 7.88593C146.111 8.51244 147.659 10.0698 147.659 11.9755C147.659 14.9832 145.078 16.5078 139.989 16.5078L123.023 16.5066ZM47.501 9.76173L43.8747 4.79649L40.2302 9.76173H47.501ZM52.4295 16.5066L50.2256 13.498H37.5032L35.2993 16.5066H29.3005L41.501 0.223073H46.2725L58.4258 16.5066H52.4295ZM193.278 7.8229H183.333V4.31551H193.19C195.263 4.31551 196.466 4.56015 196.976 5.08632C197.195 5.31354 197.291 5.60088 197.28 5.98773C197.231 7.14995 196.561 7.8229 193.278 7.8229ZM204.985 16.5066L198.051 10.9443C201.217 10.2328 202.948 8.48839 202.948 5.98027C202.948 2.26805 199.87 0.223073 194.281 0.223073H177.688V16.5066H183.333V11.6699H192.041L197.785 16.5066H204.985Z"
                fill="white"
              />
            </svg>
          </GaryBarlowCta>
        )}
      </Header>

      <Title celebName={celebName}>
        Site Closed<br/>This Competition{celebName === 'emily' ? ' ' : <br/>}Has Ended
      </Title>
      {/* <Route
        path={
          celebName === 'emily'
            ? `/emily-burns-photonlens`
            : `/gary-barlow-photonlens`
        }
        exact
      >
        <YoutubeIFrame>
          {celebName === 'emily' ? (
            <iframe
              title="emily burns"
              width="294"
              height="192"
              src="https://www.youtube.com/embed/VQVhtivLRZA"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <iframe
              title="gary burlow"
              width="294"
              height="192"
              src="https://www.youtube.com/embed/ZyutxpgHrOE"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </YoutubeIFrame>
        <Card celebName={name} />
        <Form setEmail={setEmail} comeFrom={comeFrom}/>
      </Route>

      <Route
        path={`/gary-barlow-photonlens/submitted`}
        render={() => <ThanksCard comeFrom={comeFrom} celebName="gary" email={email} />}
        exact
      />
      <Route
        path={`/emily-burns-photonlens/submitted`}
        render={() => <ThanksCard comeFrom={comeFrom} celebName="emily" email={email} />}
        exact
      />

      <Route
        path={`/gary-barlow-photonlens/user`}
        render={() => <EmailConfirmation comeFrom={comeFrom} celebName="gary" email={email}/>}
        exact
      />
      <Route
        path={`/emily-burns-photonlens/user`}
        render={() => <EmailConfirmation comeFrom={comeFrom} celebName="emily" email={email}/>}
        exact
      /> */}
      <Footer />
    </Root>
  );
}
